import {ACTION_TARGET} from './types/types';

export function actionTarget(info) {
  return {
    type: ACTION_TARGET,
    payload: {
      data: info
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/actionTarget.js